
































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { ModelSync, Prop } from 'vue-property-decorator'

@Component
export default class Pagination extends Vue {
  @ModelSync('value', 'input') model!: number
  @Prop() rowsNumber!: number
  @Prop() rowsPerPage!: number
  @Prop({ default: 5 }) maxPages: number
  @Prop({ default: 0 }) startAt: number
  @Prop({ default: 0 }) endAt: number
  @Prop({ default: 0 }) allItemNumber: number

  get numberOfPages() {
    return Math.ceil(this.rowsNumber / this.rowsPerPage)
  }

  get startAtValue() {
    return Number.isInteger(this.startAt) && this.startAt > 0 ? this.startAt : 0
  }

  get endAtValue() {
    return Number.isInteger(this.endAt) && this.endAt > 0 ? this.endAt : 0
  }

  get showInfo() {
    return this.startAt > 0 && this.endAt > 0 && this.allItemNumber > 0
  }
}
